
import React from 'react';

const FamilyLoadingState = () => {
  return (
    <div className="flex justify-center items-center min-h-[200px]">
      <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
    </div>
  );
};

export default FamilyLoadingState;
